@import "../fonts.css";
@import "../colors.css";

input.CoreInputBox-input,
textarea.CoreInputBox-input {
	height: calc(100% - 20px);
}
